export default "__VITE_ASSET__CzDxAhPZ__"